import React, { useState } from "react";
import { History } from "lucide-react";

const KIND = {
    added: "border-emerald-400/40 text-emerald-300",
    changed: "border-sky-400/40 text-sky-300",
    removed: "border-rose-400/40 text-rose-300",
    fixed: "border-amber-400/40 text-amber-300",
};

/** Latest version that touched the endpoint — shown on the collapsed row. */
export function LatestChangeChip({ history, testId }) {
    if (!history?.length) return null;
    return (
        <span data-testid={testId} title={`Last changed in v${history[0].version} (${history[0].date || "—"}) — see Change history`}
              className="text-[9px] font-mono px-1.5 py-0.5 rounded border border-white/10 text-white/45">v{history[0].version}</span>
    );
}

/** `x-change-history` of one operation: version · date · title, then each added / changed / removed / fixed item. */
export default function ChangeHistory({ history, testId = "op-change-history" }) {
    const [all, setAll] = useState(false);
    const rows = history || [];
    const shown = all ? rows : rows.slice(0, 3);
    return (
        <div data-testid={testId}>
            <div className="text-white/40 uppercase tracking-wider text-[10px] mb-1 flex items-center gap-1"><History className="w-3 h-3" /> Change history</div>
            {rows.length === 0 ? (
                <div className="text-[11px] text-white/40" data-testid={`${testId}-empty`}>No recorded changes — every change from v2.18.0 on is listed here.</div>
            ) : (
                <ol className="space-y-2 border-l border-white/10 pl-3">
                    {shown.map((h) => (
                        <li key={h.version} data-testid={`${testId}-${h.version}`}>
                            <div className="flex items-baseline gap-2 flex-wrap">
                                <span className="font-mono text-[11px] text-white/85">v{h.version}</span>
                                <span className="text-[10px] text-white/40 tabular-nums">{h.date}</span>
                                {h.title && <span className="text-[11px] text-white/55">{h.title}</span>}
                            </div>
                            <ul className="mt-1 space-y-0.5">
                                {h.changes.map((c, i) => (
                                    <li key={i} className="text-[11px] text-white/65 flex gap-1.5 items-baseline">
                                        <span className={`text-[9px] uppercase tracking-wider px-1 rounded border shrink-0 ${KIND[c.kind] || KIND.changed}`}>{c.kind}</span>
                                        <span>{c.field && <code className="text-white/85 bg-white/5 px-1 rounded">{c.field}</code>}{c.field && c.text ? " — " : ""}{c.text}</span>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ol>
            )}
            {rows.length > 3 && (
                <button onClick={() => setAll(!all)} data-testid={`${testId}-toggle`} className="mt-1 text-[10px] text-white/45 hover:text-white">
                    {all ? "Show fewer" : `Show all ${rows.length} versions`}
                </button>
            )}
        </div>
    );
}
